import { useId } from 'react'
import { Unplug } from 'lucide-react'
import { Icon } from '../../platform/icons/Icon'
import { ButtonLink } from '../../platform/primitives/ButtonLink'
import { Panel } from '../../platform/primitives/Panel'

/**
 * S11's reconnect note, one component for the list's banner and the detail's
 * note (shape §4.6). Not an error and not an alert: everything around it still
 * renders, and Mark paid stays available. The sentence names the section, so a
 * screen reader hears why the Reconnect link is there.
 */
export function ReconnectBanner({ text }: { text: string }) {
  const id = useId()
  return (
    <Panel className="rec-banner">
      <section aria-labelledby={id} className="rec-banner__body">
        <span className="rec-banner__icon">
          <Icon glyph={Unplug} size={18} />
        </span>
        <span id={id} className="rec-banner__text">
          {text}
        </span>
        <ButtonLink to="/connections" variant="outline" size="panel" className="rec-banner__action">
          Reconnect
        </ButtonLink>
      </section>
    </Panel>
  )
}
